import _ from "underscore";
import Translator from "../../utils/translator";
import { Dialog } from "./dialog";
import { CancelablePromise as Promise } from "../../utils/cancelablePromise";
import template from "./startOfDayDialog.tmpl";

type TStartOfDayDialogCallback = (startOfDay?: string) => void;

interface IStartOfDayDialogOptions {
    translator: Translator;
    isUserNightMode: boolean;
    persistent?: boolean;
}

export default class StartOfDayDialog {
    private readonly translator: Translator;
    private readonly isUserNightMode: boolean;
    private readonly persistent?: boolean;
    private dialog: Dialog;

    constructor(options: IStartOfDayDialogOptions) {
        this.translator = options.translator;
        this.isUserNightMode = options.isUserNightMode;
        this.persistent = options.persistent;
    }

    getSelectedDateTime() {
        let dialog = this.dialog;
        let hours = (<HTMLInputElement>dialog.el?.querySelector(".datetime__hours")).value;
        let minutes = (<HTMLInputElement>dialog.el?.querySelector(".datetime__minutes")).value;
        return `${ hours }:${ minutes }:00`;
    }

    open(currentStartOfDay: string | null, disabled: boolean) {
        return new Promise<string | null>((resolve, reject) => {
            return this.openStartOfDayDialog(currentStartOfDay, disabled, resolve, reject).catch(reject);
        });
    }

    close() {
        this.dialog && this.dialog.remove();
    }

    private openStartOfDayDialog(currentStartOfDay: string | null, disabled: boolean, onSelect: TStartOfDayDialogCallback, onReject: TStartOfDayDialogCallback) {
        let startOfDayHours = 0;
        let startOfDayMinutes = 0;
        if (currentStartOfDay) {
            let hoursAndMins = currentStartOfDay.split(":");
            startOfDayHours = parseInt(hoursAndMins[0]);
            startOfDayMinutes = parseInt(hoursAndMins[1]);
        }

        let templateStr = (_.template(template))({
            selectedHour: startOfDayHours,
            selectedMinute: startOfDayMinutes,
            disabled
        });

        this.dialog = new Dialog(
            "select-start-of-day",
            `<div class="selectDialogContent">${ templateStr }</div>`,
            this.translator,
            disabled ? "Start of day" : "Choose start of day",
            [
                [{
                    text: "Done",
                    id: "start-of-day-done",
                    spinner: true,
                    callback: () => onSelect(this.getSelectedDateTime())
                }]
            ],
            {
                isNightMode: this.isUserNightMode,
                persistent: this.persistent ?? false,
                intervenient: true,
                onCancelCallback: onReject
            }
        );
        return this.dialog.open();
    }
}